<template>
  <div class="login-container">
    <div id="particles-js" class="particles-container"></div>
    <div class="cyber-background">
      <div class="grid"></div>
    </div>
    <el-card class="login-card">
      <div class="company-logo">
        <div class="logo-circle">
          <div class="logo-pulse"></div>
          <div class="logo-text">YD</div>
        </div>
        <div class="company-name">
          <div class="name-cn">亿大智能科技</div>
          <div class="name-en">YIDA INTELLIGENT TECHNOLOGY</div>
          <div class="name-location">GUANGZHOU CO., LTD.</div>
        </div>
      </div>
      <div class="system-title">
        <div class="title">SDK授权管理平台</div>
        <div class="subtitle">AUTHORIZATION SYSTEM</div>
        <div class="title-line"></div>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-form-item prop="username">
          <el-input 
            v-model="loginForm.username" 
            placeholder="用户名 / USERNAME"
            prefix-icon="el-icon-user"
            class="cyber-input">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            type="password" 
            placeholder="密码 / PASSWORD"
            prefix-icon="el-icon-lock"
            @keyup.enter.native="handleLogin"
            class="cyber-input">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            :loading="loading"
            @click="handleLogin" 
            class="cyber-button">
            <span>登录系统</span>
          </el-button>
        </el-form-item>
      </el-form>
      <div class="cyber-footer">
        <div class="footer-text">SECURITY · INNOVATION · TECHNOLOGY</div>
      </div>
    </el-card>
  </div>
</template>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #1a1f35 0%, #0a192f 100%);
  position: relative;
  overflow: hidden;
}

.particles-container {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.cyber-background {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.grid {
  position: absolute;
  width: 200%;
  height: 200%;
  background-image: 
    linear-gradient(transparent 95%, rgba(0, 255, 255, 0.1) 95%),
    linear-gradient(90deg, transparent 95%, rgba(0, 255, 255, 0.1) 95%);
  background-size: 50px 50px;
  transform: perspective(500px) rotateX(45deg);
  animation: gridMove 20s linear infinite;
}

.login-card {
  width: 400px;
  background: rgba(26, 31, 53, 0.8);
  border: 1px solid rgba(0, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  z-index: 2;
}

.company-logo {
  text-align: center;
  margin-bottom: 30px;
}

.logo-circle {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  position: relative;
  background: linear-gradient(45deg, #00ffff, #0066ff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-pulse {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #00ffff;
  animation: pulse 2s infinite;
}

.logo-text {
  color: white;
  font-size: 24px;
  font-weight: bold;
  z-index: 1;
}

.company-name {
  margin-top: 15px;
}

.name-cn {
  font-size: 24px;
  color: #00ffff;
  margin-bottom: 5px;
  font-weight: bold;
}

.name-en {
  font-size: 12px;
  color: #4a9eff;
  letter-spacing: 2px;
  margin-bottom: 2px;
}

.name-location {
  font-size: 10px;
  color: #4a9eff;
}

.system-title {
  text-align: center;
  margin-bottom: 30px;
}

.title {
  font-size: 24px;
  color: #00ffff;
  margin-bottom: 5px;
  font-weight: bold;
}

.subtitle {
  font-size: 14px;
  color: #4a9eff;
  letter-spacing: 2px;
}

.title-line {
  width: 50%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00ffff, transparent);
  margin: 15px auto 0;
}

.cyber-input >>> .el-input__inner {
  background: rgba(16, 24, 39, 0.6);
  border: 1px solid rgba(0, 255, 255, 0.2);
  color: white;
}

.cyber-input >>> .el-input__inner:focus {
  border-color: #00ffff;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.2);
}

.cyber-input >>> .el-input__prefix {
  color: #00ffff;
}

.cyber-button {
  width: 100%;
  background: transparent;
  border: 1px solid #00ffff;
  color: #00ffff;
  height: 40px;
  font-size: 16px;
  transition: all 0.3s;
}

.cyber-button:hover {
  background: rgba(0, 255, 255, 0.1);
  box-shadow: 0 0 15px rgba(0, 255, 255, 0.3);
}

.cyber-footer {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 255, 255, 0.1);
}

.footer-text {
  color: #4a9eff;
  font-size: 12px;
  letter-spacing: 2px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

@keyframes gridMove {
  0% { transform: perspective(500px) rotateX(45deg) translateY(0); }
  100% { transform: perspective(500px) rotateX(45deg) translateY(-50px); }
}
</style>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  mounted() {
    this.initParticles()
  },
  methods: {
    initParticles() {
      particlesJS('particles-js', {
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 800
            }
          },
          color: {
            value: '#00ffff'
          },
          shape: {
            type: 'circle'
          },
          opacity: {
            value: 0.5,
            random: false
          },
          size: {
            value: 3,
            random: true
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: '#00ffff',
            opacity: 0.4,
            width: 1
          },
          move: {
            enable: true,
            speed: 2,
            direction: 'none',
            random: false,
            straight: false,
            out_mode: 'out',
            bounce: false
          }
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: {
              enable: true,
              mode: 'repulse'
            },
            onclick: {
              enable: true,
              mode: 'push'
            },
            resize: true
          }
        },
        retina_detect: true
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            const response = await axios({
              method: 'post',
              url: '/api/auth/login',
              data: {
                username: this.loginForm.username,
                password: this.loginForm.password
              }
            })
            
            if (response.data.access_token) {
              localStorage.setItem('token', response.data.access_token)
              localStorage.setItem('userRole', response.data.user.role)
              localStorage.setItem('userId', response.data.user.id)
              localStorage.setItem('username', this.loginForm.username)
              this.$message.success('登录成功')
              this.$router.push('/dashboard')
            }
          } catch (error) {
            console.error('Login error:', error)
            this.$message.error('登录失败，请检查用户名和密码')
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>